export default __webpack_public_path__ + "static/media/widget5-img3.9f100ca3.jfif";